<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-2 col-md-12"></div>

    <div class="bodyNuevaHistoria">

      <div class="cardsFlex">

      </div>
    </div>
    <md-dialog :md-active.sync="alertImg">
      <div class="paddingCard">
        <img :src="imageSelected" alt="Skyscraper" class="imgOperation" />
        <md-dialog-actions>
          <md-button class="md-primary" @click="alertImg = false"
            >Cerrar</md-button
          >
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>
<script>
export default {
  name: "diagnosticTools",
  components: {},
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    alertImg: false,
    imageSelected: null,
    images: [
      {
        id: 1,
        img: require("../../assets/radiographs/radiografia1.jpg")
      },
      {
        id: 2,
        img: require("../../assets/radiographs/radiografia2.jpg")
      },
      {
        id: 3,
        img: require("../../assets/radiographs/radiografia3.jpg")
      },
      {
        id: 4,
        img: require("../../assets/radiographs/radiografia4.jpg")
      }
    ]
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    alertImgFnc(img) {
      this.alertImg = true;
      this.imageSelected = img;
    }
  }
};
</script>

<style scoped>
.circleWhite {
  background-color: white !important;
}

.cardsFlex {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  margin-top: 25px;
  justify-content: space-between;
}

.cardImg {
  width: 23%;
}

/* imagen */

.imgOperation {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
}

.paddingCard {
  padding: 10px;
}
</style>
